import { render } from "./languageSwitcher.vue?vue&type=template&id=f0fc3d2c&scoped=true"
import script from "./languageSwitcher.vue?vue&type=script&lang=js"
export * from "./languageSwitcher.vue?vue&type=script&lang=js"

import "./languageSwitcher.vue?vue&type=style&index=0&id=f0fc3d2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0fc3d2c"]])

export default __exports__